/**
 * 点捕捉策略类型枚举。
 */
export enum PointSnapStrategyType {
    /** 最近点捕捉。 */
    Nearest = 'nearest',
    /** 端点和草图原点捕捉。 */
    EndpointOrigin = 'endpoint-origin',
    /** 中心点捕捉。 */
    Center = 'center',
    /** 中点捕捉。 */
    Midpoint = 'midpoint',
    /** 象限点捕捉。 */
    Quadrant = 'quadrant',
    /** 交叉点捕捉。 */
    Intersection = 'intersection',
    /** 相切捕捉。 */
    Tangent = 'tangent',
    /** 垂直捕捉。 */
    Perpendicular = 'perpendicular',
    /** 平行捕捉。 */
    Parallel = 'parallel',
    /** 水平/竖直捕捉。 */
    HorizontalVertical = 'horizontal-vertical',
    /** 与点水平/竖直捕捉。 */
    PointHorizontalVertical = 'point-horizontal-vertical',
    /** 长度捕捉。 */
    Length = 'length',
    /** 网格捕捉。 */
    Grid = 'grid',
    /** 尺在网格线显示时捕捉。 */
    DynamicRuler = 'dynamic-ruler',
    /** 角度捕捉。 */
    Angle = 'angle',
    /** 悬停在圆弧边上（非中点/端点）。 */
    OnArc = 'on-arc',
}
